import { z } from "zod";

export const editVirtualProjectSchema = z.object({
    name: z.string().min(1, { message: "This field is required" }),
    unitTypeId: z.string().min(1, { message: "This field is required" }),
    url: z.string().min(1, { message: "This field is required" })
})

export type EditVirtualProjectSchemaInput = z.infer<typeof editVirtualProjectSchema>;